import { FC, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { RootState } from '../../../store/types'
import { Nps } from '../../nps'
import { Home } from '../../home'
import { Layout } from '../../layout'
import { Clarity } from '../../clarity'
import { LoadingMfe, loadComponents } from '../../mfe'
import { AuthenticationGuard, AuthorizationGuard, Login } from '../../auth'
import { DatadogRum } from '../../rum'

const Router: FC = (): React.ReactElement => {
  const userInfo = useSelector((state: RootState) => state.auth.user.info)

  const mfeManifests = useSelector((state: RootState) => state.mfe.manifests)
  const mfeComponents = loadComponents(mfeManifests)

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<DatadogRum />}>
          <Route path='/' element={<Clarity />}>
            <Route path='/login' element={<Login />} />
            <Route path='/' element={<AuthenticationGuard />}>
              <Route path='/' element={<Nps />}>
                <Route path='/' element={<Layout />}>
                  <Route path='/' element={<AuthorizationGuard />}>
                    <Route path='/' element={<Home />} />
                    {mfeComponents.map(({ basePath, component: RemoteComponent }) => (
                      <Route
                        key={basePath}
                        path={`/${basePath}/*`}
                        element={
                          <Suspense fallback={<LoadingMfe />}>
                            <RemoteComponent userInfo={userInfo} />
                          </Suspense>
                        }
                      />
                    ))}
                    <Route path='*' element={<Navigate replace to='/' />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
